class CustomSlider extends HTMLElement {
    connectedCallback() {
        this.config = {
            slidesPerView: 3.3,
            spaceBetween: 30,
            slidesOffsetBefore:30,
            slidesOffsetAfter:30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                320: {
                    slidesPerView: 1.5,
                    spaceBetween:20,
                },
                640: {
                    slidesPerView: 2.1,
                    spaceBetween:20,
                },
                800: {
                    slidesPerView: 2.5,
                    spaceBetween:20,
                },
                1023: {
                    slidesPerView: 3.3,
                    spaceBetween:20,
                }
            }
        }
        this.swiper = new Swiper(this, this.config)
    }
}

customElements.define('custom-slider', CustomSlider);